<template>
  <div class="topic-brand-variants">
    <h4 class="text-uppercase">Brand-Specific Name Variations</h4>
    <div class="row no-gutters">
      <div class="col-12 pb-4 col-lg-4 pr-lg-4">
        <Field
          type="select"
          name="variant_brand"
          label="Brand"
          v-model="selectedBrand"
          :options="brands"
        />
      </div>
      <div class="col-12 col-lg-4 pr-lg-4 pb-lg-4">
        <Field type="text" name="variant_name" label="Name" v-model="currentName" />
      </div>
      <div class="col-12 pb-4 col-lg-4" style="padding-top:30px;">
        <a href="#" @click.prevent="add()" class="btn btn-info">Assign Variation</a>
      </div>
      <div v-if="!!variants" class="col-12 pb-4">
        <a
          v-for="(name, brand_id) in variants"
          :key="brand_id"
          class="pill mr-3 mb-3"
          href="#"
          @click.prevent="remove(brand_id)"
        >
          <span class="text">{{ name + ' (' + brandName(brand_id) + ')' }}</span>
          <icon icon="remove" class="icon" />
          <input type="hidden" :name="`variants[${brand_id}]`" :value="name" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
    brands: { type: Array, default: () => [] }
  },
  data() {
    return {
      variants: {},
      selectedBrand: null,
      currentName: null
    };
  },
  watch: {
    value(val) {
      this.variants = _.cloneDeep(val);
    },
    variants(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    add() {
      if (!this.selectedBrand || !this.currentName) {
        alert("Please select a brand and enter a name variation.");
        return;
      } else if (_.has(this.variants, this.selectedBrand)) {
        alert("You have already provided a variation for the selected brand.");
        return;
      }

      this.variants[this.selectedBrand] = this.currentName;
      this.selectedBrand = null;
      this.currentName = null;
    },
    remove(brand_id) {
      let variants = _.cloneDeep(this.variants);
      _.unset(variants, brand_id);
      this.variants = variants;
    },
    brandName(brand_id) {
      let brand_name = "";
      this.brands.forEach(brand => {
        if (brand.value == brand_id) {
          brand_name = brand.label;
        }
      });
      return brand_name;
    }
  },
  mounted() {
    this.variants = _.cloneDeep(this.value);
  }
};
</script>